import { Card, CardProps } from '@mantine/core';

interface Props extends CardProps {
  children: React.ReactNode;
}

export const CardContainer = (props: Props) => {
  const { children, radius = 8, withBorder = true, ...rest } = props;

  return (
    <Card
      radius={radius}
      withBorder={withBorder}
      styles={{
        root: {
          borderWidth: 2,
        },
      }}
      {...rest}
    >
      {children}
    </Card>
  );
};
